
var initSidebarModal = function() {
    jQuery('.is-triggable').click(function(e) {
        e.preventDefault();

        var src = jQuery(this).data('src');

        if (src) {
            var type = jQuery(this).data('type');
            if (type == 'video') {
                jQuery('.modal--white .modal__content').html(
                    '<div class="video-container box-shadow">' +
                        '<iframe width="420" height="315" src="https://www.youtube.com/embed/' + src + '">' +
                        '</iframe>' +
                    '</div>'
                );
            } else {
                jQuery('.modal--white .modal__content').html(
                    '<img class="box-shadow" src="' + src + '">'
                );
            }
        }

    });
}

export {
    initSidebarModal
}